import { Injectable, OnInit, OnDestroy } from '@angular/core';
import { HttpClient, HttpResponse, HttpErrorResponse } from '@angular/common/http';

import { map, catchError, take } from 'rxjs/operators';
import { of, Observable, Subscription } from 'rxjs';

import { LoggingMessageService } from './logging-message.service';
import { DataResult } from '../models/data-result.mode';
import { AuthService } from './auth.service';
import { environment } from 'src/environments/environment';
import { SubscriptionChangeService } from './subscription-change.service';


@Injectable({
    providedIn: 'root'
})
export class FederationService implements OnInit, OnDestroy {
    private $subscriptions: Subscription = new Subscription();
    private _NO_DATA = { message: '' };

    private _BASE_URL: string = environment.TokenServiceApi;
    private _LOCAL_NAVIGATION_API = environment.LocalJsonApi;
    private _LOCAL_NAVIGATION_FILENAME = 'federation';


    constructor(private http: HttpClient, private authService: AuthService, private logger: LoggingMessageService, private subscriptionService: SubscriptionChangeService) {
    }

    ngOnInit(): void {

    }

    public getFederationToken(): Observable<DataResult> {
      if (environment.UseServerForFederation) {
          return this.getFederationFromBusinessApi();
      } else {
          return this.getFederationFromLocalApi();
      }
    }

    private getFederationFromLocalApi(): Observable<DataResult> {

      return of(null);
    }

    private getFederationFromBusinessApi(): Observable<DataResult> {
        const webmethod = '/FederationToken';
        const media = 'application/json';
        const uri = `${this._BASE_URL}${webmethod}`;

        this.logger.debug('federation.service', 'getFederationFromBusinessApi', this.subscriptionService.SelectedSubscription, this.subscriptionService.AvailableSubscriptionsString, `calling url: ${uri}`, '');

        return this.http.get<any>(
            uri,
            {
                headers: { Accept: media },
                observe: 'response'
            }
        )
            .pipe(
                map(response => {
                    let result: DataResult;
                    if (response instanceof HttpResponse) {
                        const respBody: any = response.body;
                        if (response.status === 200) {
                            result = new DataResult(response.ok, response.status, response.statusText, respBody);
                        } else if (response.status === 401) {
                            result = new DataResult(false, 401, response.statusText, respBody.message);
                        } else {
                            result = new DataResult(false, 400, response.statusText, respBody.message);
                        }
                    }
                    if (response instanceof HttpErrorResponse) {
                        result = new DataResult(false, 500, response.statusText, response.message);
                    }
                    return result;
                }),
                catchError(error => {
                    this.logger.warn('federation.service', 'getFederationFromBusinessApi', this.subscriptionService.SelectedSubscription, this.subscriptionService.AvailableSubscriptionsString, 'Error caught', '');
                    const message = this.getErrorMessage(error);
                    return this.handleError(`getFederationFromBusinessApi failed`, message);
                }),
                take(1),
            );
    }

    private getErrorMessage(error: any): string {
        let message = error.message;
        if ((error.error) && (error.error.message)) {
            message = error.error.message;
        }
        return message;
    }

    private handleError(operation: string, error: any) {
        let result: any;
        const response = this._NO_DATA;
        this.logger.warn('federation.service', 'handleError', this.subscriptionService.SelectedSubscription, this.subscriptionService.AvailableSubscriptionsString, `Operation:${operation}`, `Server Error:${error}`);
        response.message = error;
        const errorResult = new DataResult(false, 503, 'Service Unavailable error', response);
        result = errorResult;

        return of(result);
    }

    unsubscribe() {
        if (this.$subscriptions) {
            this.$subscriptions.unsubscribe();
        }
    }

    ngOnDestroy(): void {
        this.unsubscribe();
    }
}

